export interface TocItem {
  id: string;
  label: string;
}

interface TableOfContentsProps {
  items: TocItem[];
}

export default function TableOfContents({ items }: TableOfContentsProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const offset = 100;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-[#111111] border border-white/10 rounded-lg p-6 mb-10">
      <p className="text-[#c8a96e] text-xs font-bold tracking-[0.2em] uppercase mb-4">
        Table of Contents
      </p>
      <ol className="space-y-2">
        {items.map((item, i) => (
          <li key={item.id} className="flex items-start gap-3">
            <span className="text-[#c8a96e] text-xs font-bold mt-0.5 w-4 flex-shrink-0">{i + 1}.</span>
            <a
              href={`#${item.id}`}
              onClick={(e) => handleClick(e, item.id)}
              className="text-gray-300 text-sm hover:text-[#c8a96e] transition-colors leading-snug"
            >
              {item.label}
            </a>
          </li>
        ))}
      </ol>
    </div>
  );
}
